// /components/DietAssessment/components/AssessmentStep.js

import React, { useEffect, useContext } from 'react';
import { Button, Box, useMediaQuery, useTheme } from '@mui/material';
import { AssessmentContext } from '../../../lib/contexts';

export const AssessmentNextStepButton = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { state, actions } = useContext(AssessmentContext);
  const { nextAllowed, currentStepInfo } = state;
  const { handleNextStep } = actions;

  // Use overrideLabel if provided, otherwise fall back to currentStepInfo
  const buttonLabel = props?.overrideLabel || currentStepInfo?.buttonText || 'Next';
  const boxSx = props?.boxSx || {};

  // Always use the onClick prop if provided, otherwise use context handler
  const onClickHandler = props?.onClick || handleNextStep;
  const isAllowed = typeof props?.disabled === 'boolean' ? !props.disabled : nextAllowed;

  return (
    <Box
      id="assessment-next-button"
      sx={{
        ...theme.globalClasses.assessmentButton,
        backgroundColor: isMobile ? 'background.paper' : 'transparent',
        ...boxSx,
      }}
    >
      <Button
        disabled={!isAllowed}
        size="large"
        variant="contained"
        onClick={onClickHandler}
        sx={{
          mb: 2,
          width: '100%',
          maxWidth: '278px',
        }}
      >
        {buttonLabel}
      </Button>
    </Box>
  );
};
